import { render, staticRenderFns } from "./DialogNotify.vue?vue&type=template&id=23a9bbda&scoped=true"
import script from "./DialogNotify.vue?vue&type=script&lang=js"
export * from "./DialogNotify.vue?vue&type=script&lang=js"
import style0 from "./DialogNotify.vue?vue&type=style&index=0&id=23a9bbda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a9bbda",
  null
  
)

export default component.exports